module.exports = {
      id: "add-user-1-usage",
      viewBox: "0 0 21.926 19.034",
      url: "img/" + "sprite.svg#add-user-1-usage",
      toString: function () {
        return this.url;
      }
    }